var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.576 0.175058C8.52018 0.230867 8.47591 0.297124 8.4457 0.370046C8.41549 0.442968 8.39994 0.521126 8.39994 0.600058C8.39994 0.678989 8.41549 0.757147 8.4457 0.830069C8.47591 0.902991 8.52018 0.969249 8.576 1.02506L11.951 4.39906H0.6C0.44087 4.39906 0.288258 4.46227 0.175736 4.57479C0.0632141 4.68732 0 4.83993 0 4.99906C0 5.15819 0.0632141 5.3108 0.175736 5.42332C0.288258 5.53584 0.44087 5.59906 0.6 5.59906H11.95L8.576 8.97606C8.51712 9.03106 8.46992 9.09735 8.43721 9.17099C8.4045 9.24463 8.38697 9.3241 8.38564 9.40466C8.38431 9.48523 8.39923 9.56523 8.42949 9.6399C8.45976 9.71458 8.50475 9.78239 8.5618 9.8393C8.61884 9.89621 8.68676 9.94104 8.7615 9.97113C8.83625 10.0012 8.91629 10.0159 8.99685 10.0144C9.0774 10.0129 9.15683 9.99519 9.23039 9.96231C9.30395 9.92943 9.37014 9.88207 9.425 9.82306L13.825 5.42406C13.9374 5.31156 14.0005 5.15906 14.0005 5.00006C14.0005 4.84106 13.9374 4.68856 13.825 4.57606L9.425 0.176058C9.36919 0.120241 9.30293 0.0759645 9.23001 0.0457563C9.15709 0.0155482 9.07893 0 9 0C8.92107 0 8.84291 0.0155482 8.76999 0.0457563C8.69707 0.0759645 8.63081 0.120241 8.575 0.176058",
    fill: "#868B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.e6ba9d43b47b2a39eebf1dbda4bc3744.svg";
export { ForwardRef as ReactComponent };